export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Options-Big-Gray-c555208c8a9df41d6f407dd06cefbaab.svg";